// import { ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
// import { ActivatedRoute, Router } from '@angular/router';
// import { rejects } from 'assert';
// import { promises, resolve } from 'dns';
// import { Observable } from 'rxjs';
// import { debounceTime, distinctUntilChanged, first, retry } from 'rxjs/operators';
// import { ApiService } from 'src/app/Services/api.service';
// import { CommonServices } from 'src/app/Services/common.service';
// import { StorageService } from 'src/app/Services/storage.service';
// import { SweetAlert } from 'src/app/Services/sweetalet.service';
// import { MatSelect } from '@angular/material/select';

// @Component({
//   selector: 'app-manage-vehicle-driver-form',
//   templateUrl: './manage-vehicle-driver-form.component.html',
//   styleUrls: ['./manage-vehicle-driver-form.component.css']
// })
// export class ManageVehicleDriverFormComponent implements OnInit {


//   public breadcrumbData = {
//     "Information": "/organization/transport-manager/information",
//     "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
//   };

//   public vendorID: any;
//   public editVehicleID: any;
//   public editObj = {};
//   public manageData: any = {};
//   public vehiclelists: any = [];
//   public driverlists = [];
//   public selectedDriver = [];
//   public selectedVehicle = [];
//   public formSubmitted: boolean = false;
//   public optionTitlecase: boolean = false;
//   public isEdit: boolean = false;

//   public enableVehicleField: boolean = true;
//   public enableDriverField: boolean = true;

//   public formObject = {
//     vehicle: '',
//     driver: '',
//     shift: ''
//   };
//   public errorObj = {};
//   public fieldOptions = {
//     vehicles: [],
//     drivers: [],
//   }
//   public routerLinkStr = '';

//   @ViewChild('vehicleSearch') vehSearchTextBox: ElementRef;
//   public vehSearchValue = '';
//   vehSearchChangeObserver: any;

//   @ViewChild('driverSearch') driverSearchTextBox: ElementRef;
//   public driverSearchValue = '';
//   driverSearchChangeObserver: any;
//   // @ViewChild('driverSelect') driverSelect: ElementRef;
//   @ViewChild('shiftSelect') shiftSelect: MatSelect;
//   // @ViewChild('shiftSelect', { static: true }) shiftSelect: ElementRef;
//   @ViewChild('driverSelect') driverSelect: MatSelect;
//   public matFormSize = '12px';
//   public extraDrivers: any = [];
//   public driverData: { [key: number]: any[] } = {};
//   public shiftTimeData = [];
//   public additionalDri = [];
//   public storedData = [];
//   public shiftDatas: any = [];
//   public shiftObjects = [];
//   shiftValues = [];
//   driversEditData = [];
//   dropdownOptions: any;
//   shiftRemove: any[] = [];
//   oldDriver = {};
//   oldVehicle = {};
//   constructor(
//     private api: ApiService,
//     private swal: SweetAlert,
//     private route: ActivatedRoute,
//     public storage: StorageService,
//     public router: Router,
//     public comService: CommonServices,
//     private changeDetectorRef: ChangeDetectorRef
//   ) {

//     let vendorName = this.storage.get('vendorID_orgID')['vendorName'];
//     // this.route.params.subscribe((params: any) => this.routeID = params['id']);
//     this.route.paramMap.subscribe(params => {
//       this.vendorID = params.get('vendorID');
//       this.editVehicleID = params.get('vehicleID');

//       if (vendorName) {
//         vendorName = this.comService.strTruncate(vendorName, 13);
//         this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.vendorID;
//       } else {
//         this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.vendorID;
//       }
//       this.breadcrumbData['Assign'] = "";

//       this.routerLinkStr = "/organization/transport-manager/information/manage/manage-vehicle/" + this.vendorID;
//       if (this.editVehicleID) {
//         this.isEdit = true;
//         this.getListShift();
//         this.getUnassignedDriver();
//         this.getAssignedVehDriver();
//       } else {
//         this.getUnassignedDriver();
//       }
//     });

//   }

//   ngOnInit(): void {
//     this.getUnassignedVeh();
//     this.getListShift();
//   }

//   getUnassignedVeh(vehRegNo?) {
//     this.enableVehicleField = false;
//     this.vehiclelists = [];
//     const obj = {
//       vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
//     };
//     if (vehRegNo) obj['vehRegNo'] = vehRegNo;

//     this.api.transportManagerUnassignVehList(obj).then((res: any) => {
//       if (res.status == 'success') {
//         if (res.data) {

//           res.data.filter(item => {
//             let model = item.model ? (item.model == 'loadVehicle' ? 'Load Vehicle' : item.model) : '';
//             let vehicleObj = {
//               name: item.vehRegNo.toUpperCase() + ' ' + model,
//               value: item.vehRegNo,
//             };
//             if (item['capacity']) {
//               vehicleObj['badge'] = item['capacity'];
//               vehicleObj['badgeClass'] = "bg-primary text-white rounded-pill px-2 badgePosRel";
//             }
//             if (this.selectedVehicle == [] || this.selectedVehicle[0] == undefined || this.selectedVehicle[0]['value'] != vehicleObj.value) {
//               this.vehiclelists.push(vehicleObj);
//             }
//           });
//         }
//       }
//       setTimeout(() => { this.enableVehicleField = true }, 200);
//     }).catch((err) => {
//       console.log(err);
//     });
//   }

//   // search
//   vehSearchChange(searchValue: string) {
//     searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

//     if (!this.vehSearchChangeObserver) {
//       new Observable(observer => {
//         this.vehSearchChangeObserver = observer;
//       }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
//         .pipe(distinctUntilChanged()) // only emit if value is different from previous value
//         .subscribe((term: any) => {
//           // your code here
//           this.getUnassignedVeh(term);
//         });
//     }

//     this.vehSearchChangeObserver.next(searchValue);
//   }

//   vehSelectionResult(value) {
//     this.selectedVehicle = [];
//     this.vehiclelists.map((veh) => {
//       if (veh.value == value) this.selectedVehicle.push(veh);
//     })
//     if (this.selectedVehicle.length > 0) {
//       this.vehiclelists.push(this.oldVehicle)
//       this.vehiclelists = this.vehiclelists.filter((veh) => veh.value != this.selectedVehicle[0].value);
//       this.oldVehicle = this.selectedVehicle[0];
//     }
//     this.vehSearchValue = '';
//     this.getUnassignedVeh();
//     if (this.formSubmitted) this.validation();
//   }
//   driverSelectionResult(value) {
//     if (this.shiftSelectValidation('first', 0)) {
//       if (Object.keys(this.oldDriver).length > 0) {
//         this.driverlists.push(this.oldDriver)
//       }
//       this.selectedDriver = [];
//       this.driverlists.map((driver) => {
//         if (driver.value == value) {
//           driver['driverPosition'] = 'primary';
//           driver['badge'] = 'P';
//           driver['badgeClass'] = "bg-primary text-white rounded-pill px-2 ml-2 badgePosRel";
//           this.selectedDriver.push(driver);
//           this.oldDriver = driver;
//         }
//       });
//       Object.keys(this.shiftObjects[0]['first']).forEach(key => {
//         this.shiftObjects[0]['first'].driverID = this.selectedDriver[0].value;
//         this.shiftObjects[0]['first'].driverName = this.selectedDriver[0].name;
//         this.shiftObjects[0]['first'].priorityLevel = "Primary";
//       });


//       if (this.formSubmitted) this.validation();
//       this.driverSearchValue = '';
//       if (Object.keys(this.driverData).length > 0) {
//         const updatedData = this.removeObjectByValue(this.driverlists, this.selectedDriver[0].value);
//         this.additionalDri = [];
//         Object.keys(this.driverData).forEach(key => {
//           delete this.driverData[key];
//           this.driverData[key] = updatedData;
//         });
//       } else {
//         this.removeObjectByValue(this.driverlists, this.selectedDriver[0].value);
//         // this.addDrivers()
//       }
//     } else {
//       this.changeDetectorRef.detectChanges();
//       this.formObject.driver = '';
//       if (this.formSubmitted) this.validation();
//       this.swal.swalFunction("Warning", "Warning", "select the shift", 2000);
//     }


//   }
//   shiftSelectValidation(shift, index) {
//     if (this.shiftObjects.length == 0 || this.shiftObjects == undefined) {
//       return false;
//     } else if (this.shiftObjects[index]?.hasOwnProperty(shift)) { return true } else { return false; }
//   }
//   removeObjectByValue(data: any, targetValue: string) {
//     this.driverlists = this.storedData.filter(item => item.value != targetValue)
//     if (this.shiftObjects[1] != undefined) {
//       const secondDriverID = this.shiftObjects[1].second.driverID;
//       if (targetValue == secondDriverID)
//         targetValue == secondDriverID ? this.shiftObjects[1].second.driverID = '' : ''
//     }
//     return this.driverlists;
//   }

//   // search

//   vehOpenedChange(e) {
//     // Set search textbox value as empty while opening selectbox
//     this.vehSearchValue = '';
//     this.vehSearchChange(this.vehSearchValue);
//     // Focus to search textbox while clicking on selectbox
//     if (e == true) {
//       this.vehSearchTextBox.nativeElement.focus();
//     }
//   }

//   clearVehSearch(event) {
//     this.vehSearchValue = '';
//     this.getUnassignedVeh();
//   }

//   getUnassignedDriver(driverName?) {
//     this.enableDriverField = false;
//     this.driverlists = [];
//     const obj = {
//       vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
//     };
//     if (driverName) obj['name'] = driverName;

//     this.api.transportManagerUnassignDriverList(obj).then((res: any) => {
//       if (res.status == 'success') {
//         if (res.data) {
//           res.data.filter(item => {
//             let driverObj = { name: item.name, value: item.driverID, };
//             if (this.selectedDriver == [] || this.selectedDriver[0] == undefined || this.selectedDriver[0]['value'] != driverObj.value)
//               this.storedData.push(driverObj)
//             this.driverlists.push(driverObj);
//           });
//         }
//       }
//       setTimeout(() => { this.enableDriverField = true }, 200);
//     }).catch((err) => {
//       console.log(err);
//     });
//   }

//   driverSearchChange(searchValue: string) {
//     searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

//     if (!this.driverSearchChangeObserver) {
//       new Observable(observer => {
//         this.driverSearchChangeObserver = observer;
//       }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
//         .pipe(distinctUntilChanged()) // only emit if value is different from previous value
//         .subscribe((term: any) => {
//           // your code here
//           this.getUnassignedDriver(term);
//         });
//     }

//     this.driverSearchChangeObserver.next(searchValue);
//   }

//   driverOpenedChange(e) {
//     // Set search textbox value as empty while opening selectbox
//     this.driverSearchValue = '';
//     this.driverSearchChange(this.driverSearchValue);
//     // Focus to search textbox while clicking on selectbox
//     if (e == true) {
//       this.driverSearchTextBox.nativeElement.focus();
//     }
//   }

//   clearDriverSearch(event) {
//     this.driverSearchValue = '';
//     this.getUnassignedDriver();
//   }

//   getAssignedVehDriver() {
//     this.enableDriverField = false;
//     this.enableVehicleField = false;

//     const obj = {
//       vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
//       vehicleID: this.editVehicleID,
//     };
//     this.api.transportManagerAssignedVehDriverList(obj).then(async (res: any) => {
//       if (res.status == 'success') {
//         if (res.data) {
//           res.data.filter(element => {
//             let item = { ...element };
//             let model = item.model ? (item.model == 'loadVehicle' ? 'Load Vehicle' : item.model) : '';
//             let vehicleObj = {
//               name: item.vehRegNo.toUpperCase() + ' ' + model,
//               value: item.vehRegNo,
//             };
//             if (item['capacity']) {
//               vehicleObj['badge'] = item['capacity'],
//                 vehicleObj['badgeClass'] = "bg-primary text-white rounded-pill px-2 badgePosRel";
//             }

//             let driverObj = {
//               name: item.driverName, value: item.driverID,
//               badge: 'P',
//               badgeClass: "bg-primary text-white rounded-pill px-2 ml-2 badgePosRel",
//               driverPosition: 'primary'
//             };


//             if (this.editVehicleID == item.vehicleID) {
//               this.selectedDriver.push(driverObj);
//               this.oldDriver = driverObj;
//               this.selectedVehicle.push(vehicleObj);
//               this.oldVehicle = vehicleObj;
//               this.storedData.push(driverObj)
//               this.editObj = { ...item };
//               this.vehiclelists.push(vehicleObj);
//               if (item?.driverShift != undefined && Array.isArray(item?.driverShift)) {
//                 item['driverShift'].map((dri, index) => {
//                   let obj = {}
//                   if (index > 0) {
//                     obj['name'] = dri.driverName;
//                     obj['value'] = dri.driverID;
//                   }
//                   if (Object.keys(obj).length > 0) {
//                     this.driverlists.push(obj);
//                     this.storedData.push(obj)
//                   }
//                 });
//               } else {

//               }

//             }
//           });
//           setTimeout(() => {
//             this.loadFormValues();
//           }, 50)
//         }
//       }
//       setTimeout(() => { this.enableDriverField = true; this.enableVehicleField }, 200);
//     }).catch((err) => {
//       console.log(err);
//     });
//   }



//   loadFormValues() {

//     if (this.selectedVehicle.length > 0) {
//       this.vehiclelists = this.vehiclelists.filter((veh) => veh.value != this.selectedVehicle[0].value)
//     }
//     this.formObject = {
//       vehicle: this.editObj['vehRegNo'],
//       driver: this.editObj['driverID'],
//       shift: this.editObj?.['shift']
//     };
//     this.shiftValues = [];
//     this.driversEditData = [];

//     if (this.editObj['driverShift']?.length > 0) {
//       for (let i = 0; i < this.editObj['driverShift'].length; i++) {
//         if (i == 0) {
//           let first = {
//             "driverID": this.editObj['driverShift'][i]?.driverID,
//             "shiftID": this.editObj['driverShift'][i]?.shiftID,
//             "priorityLevel": this.editObj['driverShift'][i]?.priorityLevel
//           }
//           let obj = { first }
//           this.shiftObjects[0] = obj;
//         }
//         if (i > 0) {
//           this.addDrivers();
//           this.shiftValues = this.editObj['driverShift'][i].shiftID;
//           this.driversEditData = this.editObj['driverShift'][i].driverID;
//           if (i == 1) {
//             let second = {
//               "driverID": this.editObj['driverShift'][i].driverID,
//               "shiftID": this.editObj['driverShift'][i].shiftID,
//               "priorityLevel": this.editObj['driverShift'][i].priorityLevel
//             }
//             let obj = { second }
//             this.shiftObjects[i] = obj;
//           }
//           if (i == 2) {
//             let third = {
//               "driverID": this.editObj['driverShift'][i].driverID,
//               "shiftID": this.editObj['driverShift'][i].shiftID,
//               "priorityLevel": this.editObj['driverShift'][i].priorityLevel
//             }
//             let obj = { third }
//             this.shiftObjects[i] = obj;
//           }
//           if (i == 3) {
//             let last = {
//               "driverID": this.editObj['driverShift'][i].driverID,
//               "shiftID": this.editObj['driverShift'][i].shiftID,
//               "priorityLevel": this.editObj['driverShift'][i].priorityLevel
//             }
//             let obj = { last }
//             this.shiftObjects[i] = obj;
//           }
//         }
//         this.editObj['driverShift'][i].priorityLevel == 'Primary' ? this.formObject['shift'] = this.editObj['driverShift'][i].shiftID : '';
//       }
//     }
//     else {
//       this.driverlists = this.getDriverOptions();
//       let first = {
//         "driverID":  this.editObj['driverID'],
//         "priorityLevel":'Primary'
//       }
//       let obj = { first }
//       this.shiftObjects[0]=obj;
//     }
//   }

//   getSelectedVehicle(e) {
//     this.formObject['vehicle'] = e.value;
//     if (this.formSubmitted) this.validation();
//   }
//   getSelectedDriver(e) {
//     this.formObject['driver'] = e.value;
//     if (this.formSubmitted) this.validation();
//   }
//   shiftSelectionResult(e, index) {
//     if (index != undefined) {
//       if (index == 0) {
//         if (this.shiftSelectValidation('first', 0)) {
//           if (this.isEdit) {
//             if (this.shiftObjects[1] == undefined) {
//               let second = {
//                 "shiftID": e
//               };
//               let obj = { second }
//               this.shiftObjects[1] = obj;
//             } else {
//               this.shiftObjects[1].second['shiftID'] = e;
//             }
//           } else {
//             let second = {
//               "shiftID": e
//             };
//             let obj = { second }
//             this.shiftObjects[index + 1] = obj;
//           }
//           if (this.formSubmitted) this.validation();
//         } else {
//           this.changeDetectorRef.detectChanges();
//           this.shiftValues = [];
//           const matSelect = this.shiftSelect;
//           if (matSelect) {
//             matSelect.value = null; // Clear the selected value
//             matSelect.writeValue(null); // Reset the selection
//             matSelect.ngAfterContentInit(); // Re-trigger the rendering
//           }
//           if (this.formSubmitted) this.validation();
//         }

//       }
//       if (index == 1) {
//         let third = {
//           "shiftID": e
//         };
//         let obj = { third }
//         this.shiftObjects[index + 1] = obj
//       }
//       if (index == 2) {
//         let last = {
//           "shiftID": e
//         };
//         let obj = { last }
//         this.shiftObjects[index + 1] = obj
//       }
//     } else {
//       this.formObject['shift'] = e;
//       if (this.isEdit == true) {
//         if (this.shiftObjects[0]?.first == undefined) {
//           let first = {
//             "shiftID": e
//           };
//           let obj = { first }
//           this.shiftObjects[0] = obj;
//         } else {
//           this.shiftObjects[0]['first']['shiftID'] = e;
//         }
//       } else {
//         let first = {
//           "shiftID": e
//         };
//         let obj = { first }
//         this.shiftObjects[0] = obj;
//         if (this.formSubmitted) this.validation();
//       }
//     }
//   }

//   validation() {
//     let objectKeys = Object.keys(this.formObject);
//     let isValid = true;
//     for (let i = 0; i < objectKeys.length; i++) {
//       let key = objectKeys[i];
//       this.errorObj[key] = '';
//       if (this.formObject[key] == '' || this.formObject[key] == undefined || this.formObject[key] == null || this.formObject[key].length <= 0) {
//         this.errorObj[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
//         isValid = false;
//       }
//     }
//     return isValid;
//   }

//   cancel() {
//     this.router.navigate(['/organization/transport-manager/information/manage/view-manage', this.vendorID]);
//   }

//   async onSubmit() {
//     this.formSubmitted = true;
//     if (this.validation() && this.validationObj()) {
//       let apiMethod = 'transportManagerAssignVehicleDriver';
//       let obj = {
//         vehRegNo: this.formObject.vehicle,
//         driverID: this.formObject.driver,
//         vendorID: this.vendorID
//       }
//       // this.checkVale
//       if (this.isEdit) {
//         apiMethod = 'transportManagerManageVehicleDriverUpdate';
//         obj['oldDriverID'] = this.editObj['driverID'];
//       }
//       const { driverShift, drivers } = this.getDriverIDs(this.shiftObjects);
//       obj['driverShift'] = driverShift;
//       obj['drivers'] = drivers;
//       this.api[apiMethod](obj).then((res: any) => {
//         let responseStatus = '';
//         let responseMsg: any;
//         if (this.isEdit) {
//           responseStatus = res.status;
//           responseMsg = res.message;
//         } else {
//           responseStatus = res.response.status;
//           responseMsg = res.response.message;
//         }
//         if (responseStatus == 'success') {
//           this.swal.swalFunction(responseStatus, responseStatus, responseMsg, 2000);
//           this.router.navigate(['/organization/transport-manager/information/manage/view-manage', this.vendorID]);
//         } else {
//           this.swal.swalFunction(responseStatus, responseStatus, responseMsg, 2000);
//         }
//       }).catch((err) => {
//         console.log(err);
//       });

//     }
//   }


//   findMissingDriverIDs() {
//     const missingDriverIDs = {};

//     this.shiftObjects.forEach(driverObj => {
//       const key = Object.keys(driverObj)[0];
//       if (!driverObj[key].hasOwnProperty('driverID')) {
//         missingDriverIDs[key] = false;
//       }
//     });

//     return missingDriverIDs;
//   }

//   validationObj() {
//     if ((this.shiftObjects[1]?.second?.shiftID != undefined) && (this.shiftObjects[1]?.second?.driverID == undefined || this.shiftObjects[1]?.second?.driverID?.length == 0)) {
//       this.swal.swalFunction("warning", "warning", "Select the secondary driver to complete the setup!", 2000)
//       return false
//     } else {
//       return true;
//     }
//     // const missingDriverIDs = this.findMissingDriverIDs();
//     // console.log("missingDriverIDs",missingDriverIDs)
//     // if (Object.keys(missingDriverIDs).length > 0) {
//     //   console.log('Validation Error: Missing driverID for keys - ' + Object.keys(missingDriverIDs).join(', '))
//     //   // throw new Error('Validation Error: Missing driverID for keys - ' + Object.keys(missingDriverIDs).join(', '));
//     //   // this.comService.swa
//     //   return false;
//     // } else {
//     //   return true;
//     // }
//   }
//   getDriverIDs(driversData) {
//     const flattenedDrivers = driversData.map(driverObj => Object.values(driverObj)[0]);
//     const driverShift = flattenedDrivers.sort((a, b) => {
//       return a.priorityLevel == "Primary" ? -1 : 1;
//     });
//     const drivers = driverShift.map(driver => driver.driverID);

//     return { driverShift, drivers };

//   }

//   addDrivers() {
//     // const newIndex = this.extraDrivers.length;
//     // this.extraDrivers.push(newIndex);
//     this.driverlists = this.getDriverOptions();
//     // this.shiftDatas[newIndex] = this.getShifOption(newIndex);

//   }

//   getDriverOptions() {
//     let output;
//     if (this.selectedDriver.length > 0 && this.selectedDriver != undefined) {
//       // output = this.driverlists.filter(item => item.value != this.selectedDriver[0].value);
//       if (this.additionalDri?.length > 0) {
//         output = this.driverlists.filter(item =>
//           item.value != this.selectedDriver[0].value && !this.additionalDri?.includes(item.value)
//         );
//       } else {
//         output = this.driverlists.filter(item => item.value != this.selectedDriver[0].value);

//       }

//     } else {
//       output = this.driverlists;
//     }
//     return output;
//   }

//   getShifOption(index: number) {
//     return this.shiftTimeData
//   }

//   // removeDrivers(index: number): void {

//   //   // let arr = this.extraDrivers.filter(value => value != index);
//   //   // this.extraDrivers = arr.map((value, index) => index);
//   //   if (index == 0) {
//   //     this.shiftValues[index] = null;
//   //     this.extraDrivers.splice(index, 1);
//   //     this.removeAndReassignKeys(0);

//   //   }
//   //   if (index == 1) {
//   //     this.removeAndReassignKeys(1)
//   //     // this.shiftSelect.writeValue(null); 
//   //     this.shiftValues[index] = null;
//   //     // const matSelect = this.shiftSelects.toArray()[index];
//   //     // if (matSelect) {
//   //     //   matSelect.value = null; // Clear the selected value
//   //     //   matSelect.writeValue(null); // Reset the selection
//   //     //   matSelect.ngAfterContentInit(); // Re-trigger the rendering
//   //     // }
//   //     this.extraDrivers.splice(index, 1);
//   //   }
//   //   if (index == 2) {
//   //     this.removeAndReassignKeys(2)
//   //     this.shiftValues[index] = null;
//   //     this.extraDrivers.splice(index, 1);
//   //     // this.dropdownOptions[index]=null;
//   //   }



//   //   const key = index.toString();
//   //   if (this.driverData.hasOwnProperty(key)) {
//   //     if (this.additionalDri != undefined && this.additionalDri.length > 0) {
//   //       let drivData;
//   //       this.driverData[key].filter(data => {
//   //         this.additionalDri.map((val, index) => {
//   //           if (val == data.value) {
//   //             this.additionalDri.splice(index, 1)
//   //             drivData = data;
//   //             delete this.driverData[key]
//   //           }
//   //         });
//   //       });
//   //       if (drivData != undefined) {
//   //         this.pushDriverData(drivData)
//   //       }
//   //     } else {
//   //       delete this.driverData[key]
//   //     }
//   //   }

//   // }

//   removeAndReassignKeys(indexToRemove) {
//     this.shiftObjects.splice(indexToRemove + 1, 1);

//     const keyNames = ['first', 'second', 'third', 'last'];

//     this.shiftObjects = this.shiftObjects.map((item, index) => {
//       const newKey = keyNames[index];
//       return { [newKey]: item[Object.keys(item)[0]] };
//     });

//     return this.shiftObjects;
//   }
//   pushDriverData(driverObj) {
//     for (let key in this.driverData) {
//       if (this.driverData.hasOwnProperty(key)) {
//         this.driverData[key].push(driverObj);
//       }
//     }
//   }
//   getListShift() {
//     const obj = {
//       orgID: this.storage.get('userInfo').orgID
//     };
//     this.api.ListShift(obj).then((res: any) => {
//       if (res?.data?.length > 0 && res?.status == 'success') {
//         this.shiftTimeData = res.data;
//       }
//     }).catch((err) => {
//       console.log(err);
//     });
//   }

//   extradriverSelection(value: any, index) {
//     this.removeExtraDriver(value, index)
//     if (index == 0) {
//       // if(this.shiftObjects[1] == undefined){
//       //   let second = {
//       //     "shiftID": ''
//       //   };
//       //   let obj = { second }
//       //   this.shiftObjects[1] = obj;
//       // }
//       if (this.shiftSelectValidation('second', 1)) {
//         this.shiftObjects[1]['second']['driverID'] = value;
//         this.shiftObjects[1]['second']['priorityLevel'] = "noPrimary";
//         this.formObject['secondDriver'] = value;
//         this.additionalDri.push(value);
//       } else {
//         this.changeDetectorRef.detectChanges();
//         this.driversEditData = [];
//         const matSelect = this.driverSelect;
//         if (matSelect) {
//           matSelect.value = null; // Clear the selected value
//           matSelect.writeValue(null); // Reset the selection
//           matSelect.ngAfterContentInit(); // Re-trigger the rendering
//         }
//         this.swal.swalFunction("warning", "warning", "Select the shift!", 2000)
//       }
//     }
//     if (index == 1) {
//       if (this.shiftSelectValidation('third', 2)) {
//         this.shiftObjects[2]['third']['driverID'] = value;
//         this.shiftObjects[2]['third']['priorityLevel'] = "noPrimary";
//         this.additionalDri.push(value);
//       } else {
//         // this.dropdownOptions[index]=null;
//         this.changeDetectorRef.detectChanges();
//         this.swal.swalFunction("warning", "warning", "Select the shift!", 2000)
//       }
//     }
//     if (index == 2) {
//       if (this.shiftSelectValidation('last', 3)) {
//         this.shiftObjects[3]['last']['driverID'] = value;
//         this.shiftObjects[3]['last']['priorityLevel'] = "noPrimary";
//         this.additionalDri.push(value);
//       } else {
//         // this.dropdownOptions[index]=null;
//         this.changeDetectorRef.detectChanges();
//         this.swal.swalFunction("warning", "warning", "Select the shift!", 2000)
//       }

//     }
//   }

//   removeExtraDriver(value, index) {
//     Object.keys(this.driverData).forEach(key => {
//       if (key != index) {
//         this.driverData[key] = this.driverData[key].filter(driv => driv.value != value)
//       }
//     });
//   }
//   resetValue() {
//     this.driversEditData = [];
//     this.shiftValues = [];
//     this.shiftObjects.splice(1, 1)
//     // delete this.shiftObjects[1].second
//     //   if (this.shiftObjects[1] && this.shiftObjects[1].second) {
//     //     for (let key in this.shiftObjects[1].second) {
//     //         if (this.shiftObjects[1].second.hasOwnProperty(key)) {
//     //           this.shiftObjects[1].second[key] = '';
//     //         }
//     //     }
//     // }
//   }
// }
import { ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { rejects } from 'assert';
import { promises, resolve } from 'dns';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, retry } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-manage-vehicle-driver-form',
  templateUrl: './manage-vehicle-driver-form.component.html',
  styleUrls: ['./manage-vehicle-driver-form.component.css']
})
export class ManageVehicleDriverFormComponent implements OnInit {


  public breadcrumbData = {
    "Information": "/organization/transport-manager/information",
    "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
  };

  public vendorID: any;
  public editVehicleID: any;
  public editObj = {};
  public manageData: any = {};
  public vehiclelists: any = [];
  public driverlists = []; // For primary driver dropdown
  public secondaryDriverlists = []; // For secondary driver dropdown
  public allDriversList = [];
  public selectedDriver = [];
  public selectedSecondaryDriver = []; // New: keep selected secondary driver separately like primary
  public selectedVehicle = [];
  public formSubmitted: boolean = false;
  public optionTitlecase: boolean = false;
  public isEdit: boolean = false;
  public isInitialLoad: boolean = true; // Track if this is initial load in edit mode
  public initialPrimaryShift: any = null; // Store initial primary shift value
  public initialSecondaryShift: any = null; // Store initial secondary shift value

  public enableVehicleField: boolean = true;
  public enableDriverField: boolean = true;

  public formObject = {
    vehicle: '',
    driver: '',
    shift: ''
  };
  public errorObj = {};
  public fieldOptions = {
    vehicles: [],
    drivers: [],
  }
  public routerLinkStr = '';
  public badgeTooltipMap = {
    P: 'Primary',
    S: 'Secondary'
  };

  @ViewChild('vehicleSearch') vehSearchTextBox: ElementRef;
  public vehSearchValue = '';
  vehSearchChangeObserver: any;

  @ViewChild('driverSearch') driverSearchTextBox: ElementRef;
  public driverSearchValue = '';
  driverSearchChangeObserver: any;
  // @ViewChild('driverSelect') driverSelect: ElementRef;
  @ViewChild('shiftSelect') shiftSelect: MatSelect;
  // @ViewChild('shiftSelect', { static: true }) shiftSelect: ElementRef;
  @ViewChild('driverSelect') driverSelect: MatSelect;
  public matFormSize = '12px';
  public extraDrivers: any = [];
  public driverData: { [key: number]: any[] } = {};
  public shiftTimeData = [];
  public secondaryShiftData = []; // Filtered shifts for secondary dropdown
  public additionalDri = [];
  public storedData = [];
  public shiftDatas: any = [];
  public shiftObjects = [];
  shiftValues = [];
  driversEditData = [];
  dropdownOptions: any;
  shiftRemove: any[] = [];
  oldDriver: any = {};
  oldSecondaryDriver: any = {}; // New: track previous secondary driver like primary
  oldVehicle: any = {};
  selectedVehicleBranch: any = null;
  originalVehicle: any = null; // Track the original vehicle in edit mode
  constructor(
    private api: ApiService,
    private swal: SweetAlert,
    private route: ActivatedRoute,
    public storage: StorageService,
    public router: Router,
    public comService: CommonServices,
    private changeDetectorRef: ChangeDetectorRef
  ) {

    let vendorName = this.storage.get('vendorID_orgID')['vendorName'];
    // this.route.params.subscribe((params: any) => this.routeID = params['id']);
    this.route.paramMap.subscribe(params => {
      this.vendorID = params.get('vendorID');
      this.editVehicleID = params.get('vehicleID');

      if (vendorName) {
        vendorName = this.comService.strTruncate(vendorName, 13);
        this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.vendorID;
      } else {
        this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.vendorID;
      }
      this.breadcrumbData['Assign'] = "";

      this.routerLinkStr = "/organization/transport-manager/information/manage/manage-vehicle/" + this.vendorID;
      if (this.editVehicleID) {
        this.isEdit = true;
        // In edit mode, getAssignedVehDriver will call getUnassignedDriver after branch is set
        this.getAssignedVehDriver();
      } else {
        this.getUnassignedDriver();
      }
    });

  }

  ngOnInit(): void {
    this.getUnassignedVeh();
  }

  getUnassignedVeh(vehRegNo?) {
    this.enableVehicleField = false;
    const currentVehicleList = [...this.vehiclelists]; // Preserve current list
    this.vehiclelists = [];
    const obj = {
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };
    if (vehRegNo) obj['vehRegNo'] = vehRegNo;

    this.api.transportManagerUnassignVehList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data) {
          res.data.filter(item => {
            console.log('Vehicle data:', item); // Debug log
            let model = item.model ? (item.model == 'loadVehicle' ? 'Load Vehicle' : item.model) : '';
            let vehicleObj = {
              name: item.vehRegNo.toUpperCase() + ' ' + model,
              value: item.vehRegNo,
              branch: item.branch || item.branchID || null
            };
            if (item['capacity']) {
              vehicleObj['badge'] = item['capacity'];
              vehicleObj['badgeClass'] = "bg-primary text-white rounded-pill px-2 badgePosRel";
            }
            if (this.selectedVehicle.length === 0 || this.selectedVehicle[0] == undefined || this.selectedVehicle[0]['value'] != vehicleObj.value) {
            this.vehiclelists.push(vehicleObj);
            }
            // if (this.selectedVehicle === [0] || this.selectedVehicle[0] == undefined || this.selectedVehicle[0]['value'] != vehicleObj.value) {
            //   this.vehiclelists.push(vehicleObj);
            // }
          });
          
          // In edit mode, ensure the original vehicle is in the list if we've changed vehicles
          if (this.isEdit && this.originalVehicle && this.formObject.vehicle !== this.originalVehicle) {
            const originalExists = this.vehiclelists.find(v => v.value === this.originalVehicle);
            const originalInOldList = currentVehicleList.find(v => v.value === this.originalVehicle);
            if (!originalExists && originalInOldList) {
              this.vehiclelists.push(originalInOldList);
            }
          }
        }
      }
      setTimeout(() => { this.enableVehicleField = true }, 200);
    }).catch((err) => {
      console.log(err);
    });
  }

  // search
  vehSearchChange(searchValue: string) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.vehSearchChangeObserver) {
      new Observable(observer => {
        this.vehSearchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.getUnassignedVeh(term);
        });
    }

    this.vehSearchChangeObserver.next(searchValue);
  }

  vehSelectionResult(value) {
    this.selectedVehicle = [];
    this.vehiclelists.map((veh) => {
      if (veh.value == value) this.selectedVehicle.push(veh);
    })
    if (this.selectedVehicle.length > 0) {
      // In edit mode, add the original vehicle back to the list if it's different from new selection
      if (this.isEdit && this.originalVehicle && this.originalVehicle !== value) {
        // Find the original vehicle object and add it back
        const originalVehObj = this.vehiclelists.find(v => v.value === this.originalVehicle) || 
                               (this.oldVehicle && this.oldVehicle.value === this.originalVehicle ? this.oldVehicle : null);
        if (originalVehObj && !this.vehiclelists.find(v => v.value === this.originalVehicle)) {
          this.vehiclelists.push(originalVehObj);
        }
      } else if (this.oldVehicle && this.oldVehicle.value) {
        this.vehiclelists.push(this.oldVehicle);
      }
      
      this.vehiclelists = this.vehiclelists.filter((veh) => veh.value != this.selectedVehicle[0].value);
      this.oldVehicle = this.selectedVehicle[0];
      
      // Reset driver selection when vehicle changes
      this.formObject.driver = '';
      this.selectedDriver = [];
      this.shiftTimeData = [];
      this.formObject.shift = '';
      
      // Fetch full vehicle details to get branch information
      this.getVehicleBranch(value);
      
      // Reload unassigned vehicles but preserve the original in edit mode
      this.vehSearchValue = '';
      this.getUnassignedVeh();
    }
    if (this.formSubmitted) this.validation();
  }
  // driverSelectionResult(value) {
  //   if (this.shiftSelectValidation('first', 0)) {
  //     this.selectedDriver = [];
      
  //     // Find the selected driver
  //     let foundDriver = null;
  //     this.driverlists.forEach((driver) => {
  //       if (driver.value == value) {
  //         foundDriver = { ...driver }; // Clone the driver object
  //         foundDriver['driverPosition'] = 'primary';
  //         foundDriver['badge'] = 'P';
  //         foundDriver['badgeClass'] = "bg-primary text-white rounded-pill px-2 ml-2 badgePosRel";
  //         this.selectedDriver.push(foundDriver);
  //       }
  //     });
      
  //     // Update shift object
  //     Object.keys(this.shiftObjects[0]['first']).forEach(key => {
  //       this.shiftObjects[0]['first'].driverID = this.selectedDriver[0].value;
  //       this.shiftObjects[0]['first'].driverName = this.selectedDriver[0].name;
  //       this.shiftObjects[0]['first'].priorityLevel = "Primary";
  //     });
      
  //     // Check if the selected primary driver is the same as the secondary driver
  //     if (this.shiftObjects[1]?.second?.driverID === value) {
        
  //       // Clear secondary driver selection
  //       this.driversEditData = [];
  //       this.shiftObjects[1].second.driverID = '';
  //       this.shiftObjects[1].second.driverName = '';
  //     }
      
  //     // Always refresh secondary driver list to exclude the newly selected primary driver
  //     if (this.selectedVehicleBranch && this.shiftObjects[1]?.second?.shiftID) {
        
  //       this.filterSecondaryDriversByBranchAndShift(this.selectedVehicleBranch, this.shiftObjects[1].second.shiftID, false);
  //     }

  //     // Remove selected driver from driverlists and update storedData
  //     this.driverlists = this.driverlists.filter(d => d.value !== value);
  //     this.storedData = [...this.driverlists];
      
  //     // Update oldDriver
  //     this.oldDriver = foundDriver;

  //     if (this.formSubmitted) this.validation();
  //     this.driverSearchValue = '';
      
  //     if (Object.keys(this.driverData).length > 0) {
  //       this.additionalDri = [];
  //       Object.keys(this.driverData).forEach(key => {
  //         delete this.driverData[key];
  //         this.driverData[key] = [...this.driverlists];
  //       });
  //     }
  //   } else {
  //     this.changeDetectorRef.detectChanges();
  //     this.formObject.driver = '';
  //     if (this.formSubmitted) this.validation();
  //     this.swal.swalFunction("Warning", "Warning", "select the shift", 2000);
  //   }


  // }

  driverSelectionResult(value) {

  if (this.shiftSelectValidation('first', 0)) {

    // 🔹 Restore previous primary driver back to dropdown
    if (this.oldDriver && this.oldDriver.value) {
      const exists = this.driverlists.find(d => d.value === this.oldDriver.value);
      if (!exists) {
        this.driverlists.push(this.oldDriver);
      }
    }

    this.selectedDriver = [];

    // 🔹 Find selected driver
    let foundDriver = this.driverlists.find(driver => driver.value == value);

    if (foundDriver) {

      let driverObj = {
        ...foundDriver,
        driverPosition: 'primary',
        badge: 'P',
        badgeClass: "bg-primary text-white rounded-pill px-2 ml-2 badgePosRel"
      };

      this.selectedDriver.push(driverObj);

      // 🔹 Update shift object
      if (this.shiftObjects[0]?.first) {
        this.shiftObjects[0].first.driverID = driverObj.value;
        this.shiftObjects[0].first.driverName = driverObj.name;
        this.shiftObjects[0].first.priorityLevel = "Primary";
      }
    }

    // 🔹 If same driver is selected as secondary, clear secondary
    if (this.shiftObjects[1]?.second?.driverID === value) {

      this.driversEditData = [];

      this.shiftObjects[1].second.driverID = '';
      this.shiftObjects[1].second.driverName = '';
    }

    // 🔹 Remove newly selected driver from dropdown
    this.driverlists = this.driverlists.filter(d => d.value !== value);

    // 🔹 Store previous driver
    this.oldDriver = foundDriver;

    // 🔹 Refresh secondary driver list
    if (this.selectedVehicleBranch && this.shiftObjects[1]?.second?.shiftID) {

      this.filterSecondaryDriversByBranchAndShift(
        this.selectedVehicleBranch,
        this.shiftObjects[1].second.shiftID,
        false
      );
    }

    // 🔹 Update stored data
    this.storedData = [...this.driverlists];

    if (this.formSubmitted) {
      this.validation();
    }

    this.driverSearchValue = '';

    // 🔹 Refresh additional driver lists if exist
    if (Object.keys(this.driverData).length > 0) {

      this.additionalDri = [];

      Object.keys(this.driverData).forEach(key => {

        delete this.driverData[key];

        this.driverData[key] = [...this.driverlists];
      });
    }

  } else {

    this.changeDetectorRef.detectChanges();

    this.formObject.driver = '';

    if (this.formSubmitted) {
      this.validation();
    }

    this.swal.swalFunction(
      "Warning",
      "Warning",
      "select the shift",
      2000
    );
  }
}

  shiftSelectValidation(shift, index) {
    if (this.shiftObjects.length == 0 || this.shiftObjects == undefined) {
      return false;
    } else if (this.shiftObjects[index]?.hasOwnProperty(shift)) { return true } else { return false; }
  }
  removeObjectByValue(data: any, targetValue: string) {
    // Reset driverlists from storedData (which already excludes selected primary driver)
    this.driverlists = [...this.storedData];
    
    // If there's a secondary driver selected, keep it out of the list
    if (this.shiftObjects[1] != undefined) {
      const secondDriverID = this.shiftObjects[1].second.driverID;
      if (secondDriverID) {
        this.driverlists = this.driverlists.filter(d => d.value !== secondDriverID);
      }
    }
    return this.driverlists;
  }

  // search

  vehOpenedChange(e) {
    // Set search textbox value as empty while opening selectbox
    this.vehSearchValue = '';
    this.vehSearchChange(this.vehSearchValue);
    // Focus to search textbox while clicking on selectbox
    if (e == true) {
      this.vehSearchTextBox.nativeElement.focus();
    }
  }

  clearVehSearch(event) {
    this.vehSearchValue = '';
    this.getUnassignedVeh();
  }

  getUnassignedDriver(driverName?): Promise<any> {
    return new Promise((resolve, reject) => {
      this.enableDriverField = false;
      // Only reset lists if not in edit mode with branch already set
      if (!this.isEdit || !this.selectedVehicleBranch) {
        this.driverlists = [];
        this.allDriversList = [];
      }
      const obj = {
        vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
      };
      if (driverName) obj['name'] = driverName;

      this.api.transportManagerUnassignDriverList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data) {
          // Clear lists before populating
          const tempDriversList = [];
          const tempAllDriversList = [];
          
          res.data.filter(item => {
            // console.log('Driver data full object:', item); // Debug log
            let driverObj = { 
              name: item.name, 
              value: item.driverID,
              branch: item.branch || item.branchID || null,
              branchName: item.branchName || null,
              shift: item.shift || item.shiftID || null,
              shiftName: item.shiftName || null
            };
            // console.log('Driver branch field:', item.branch, 'branchID field:', item.branchID, 'shift field:', item.shift); // Debug log
            tempDriversList.push(driverObj);
            tempAllDriversList.push(driverObj);
          });
          
          this.allDriversList = tempAllDriversList;
          
          // If a vehicle is already selected, filter drivers by branch and shift
          if (this.selectedVehicleBranch) {
            // console.log('Filtering drivers by vehicle branch:', this.selectedVehicleBranch);
            this.filterDriversByBranchAndShift(this.selectedVehicleBranch, this.formObject.shift);
          } else {
            this.driverlists = tempDriversList;
            this.storedData = [...tempDriversList];
          }
        }
      }
      setTimeout(() => { 
        this.enableDriverField = true;
        resolve(res);
      }, 200);
    }).catch((err) => {
      console.log(err);
      this.enableDriverField = true;
      reject(err);
    });
    });
  }

  driverSearchChange(searchValue: string) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.driverSearchChangeObserver) {
      new Observable(observer => {
        this.driverSearchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.getUnassignedDriver(term);
        });
    }

    this.driverSearchChangeObserver.next(searchValue);
  }

  driverOpenedChange(e) {
    // Set search textbox value as empty while opening selectbox
    this.driverSearchValue = '';
    this.driverSearchChange(this.driverSearchValue);
    // Focus to search textbox while clicking on selectbox
    if (e == true) {
      this.driverSearchTextBox.nativeElement.focus();
    }
  }

  clearDriverSearch(event) {
    this.driverSearchValue = '';
    this.getUnassignedDriver();
  }

  getAssignedVehDriver() {
    this.enableDriverField = false;
    this.enableVehicleField = false;

    const obj = {
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
      vehicleID: this.editVehicleID,
    };
    this.api.transportManagerAssignedVehDriverList(obj).then(async (res: any) => {
      if (res.status == 'success') {
        if (res.data) {
          res.data.filter(element => {
            let item = { ...element };
            let model = item.model ? (item.model == 'loadVehicle' ? 'Load Vehicle' : item.model) : '';
            let vehicleObj = {
              name: item.vehRegNo.toUpperCase() + ' ' + model,
              value: item.vehRegNo,
              branch: item.branch || item.branchID || null
            };
            if (item['capacity']) {
              vehicleObj['badge'] = item['capacity'],
                vehicleObj['badgeClass'] = "bg-primary text-white rounded-pill px-2 badgePosRel";
            }

            let driverObj = {
              name: item.driverName, value: item.driverID,
              badge: 'P',
              badgeClass: "bg-primary text-white rounded-pill px-2 ml-2 badgePosRel",
              driverPosition: 'primary'
            };


            if (this.editVehicleID == item.vehicleID) {
              console.log('Full item object from assigned vehicle API:', item); // Debug log
              this.selectedDriver.push(driverObj);
              this.oldDriver = driverObj;
              this.selectedVehicle.push(vehicleObj);
              this.oldVehicle = vehicleObj;
              this.originalVehicle = item.vehRegNo; // Store original vehicle for update tracking
              this.storedData.push(driverObj)
              this.editObj = { ...item };
              this.vehiclelists.push(vehicleObj);
              
              // Store secondary drivers before filtering
              const secondaryDrivers = [];
              if (item?.driverShift != undefined && Array.isArray(item?.driverShift)) {
                item['driverShift'].map((dri, index) => {
                  let obj = {}
                  if (index > 0) {
                    obj['name'] = dri.driverName;
                    obj['value'] = dri.driverID;
                  }
                  if (Object.keys(obj).length > 0) {
                    secondaryDrivers.push(obj);
                  }
                });
              }
              
              // Fetch vehicle branch details first, then load drivers and shifts
              this.getVehicleBranchForEdit(item.vehRegNo, secondaryDrivers);

            }
          });
          setTimeout(() => {
            this.loadFormValues();
          }, 50)
        }
      }
      setTimeout(() => { this.enableDriverField = true; this.enableVehicleField }, 200);
    }).catch((err) => {
      console.log(err);
    });
  }



  loadFormValues() {

    if (this.selectedVehicle.length > 0) {
      this.vehiclelists = this.vehiclelists.filter((veh) => veh.value != this.selectedVehicle[0].value)
    }
    this.formObject = {
      vehicle: this.editObj['vehRegNo'],
      driver: this.editObj['driverID'],
      shift: this.editObj?.['shift']
    };
    
    // Store initial shift values to detect changes later
    this.initialPrimaryShift = this.editObj?.['shift'];
    
    this.shiftValues = [];
    this.driversEditData = [];

    if (this.editObj['driverShift']?.length > 0) {
      for (let i = 0; i < this.editObj['driverShift'].length; i++) {
        if (i == 0) {
          let first = {
            "driverID": this.editObj['driverShift'][i]?.driverID,
            "driverName": this.editObj['driverShift'][i]?.driverName || this.editObj['driverName'] || '',
            "shiftID": this.editObj['driverShift'][i]?.shiftID,
            "priorityLevel": this.editObj['driverShift'][i]?.priorityLevel
          }
          let obj = { first }
          this.shiftObjects[0] = obj;
        }
        if (i > 0) {
          this.addDrivers();
          this.shiftValues = this.editObj['driverShift'][i].shiftID;
          // Store initial secondary shift value
          if (i == 1) {
            this.initialSecondaryShift = this.editObj['driverShift'][i].shiftID;
          }
          this.driversEditData = this.editObj['driverShift'][i].driverID;
          if (i == 1) {
            let second = {
              "driverID": this.editObj['driverShift'][i].driverID,
              "driverName": this.editObj['driverShift'][i]?.driverName || this.findDriverName(this.editObj['driverShift'][i].driverID) || '',
              "shiftID": this.editObj['driverShift'][i].shiftID,
              "priorityLevel": this.editObj['driverShift'][i].priorityLevel
            }
            let obj = { second }
            this.shiftObjects[i] = obj;
          }
          if (i == 2) {
            let third = {
              "driverID": this.editObj['driverShift'][i].driverID,
              "shiftID": this.editObj['driverShift'][i].shiftID,
              "priorityLevel": this.editObj['driverShift'][i].priorityLevel
            }
            let obj = { third }
            this.shiftObjects[i] = obj;
          }
          if (i == 3) {
            let last = {
              "driverID": this.editObj['driverShift'][i].driverID,
              "shiftID": this.editObj['driverShift'][i].shiftID,
              "priorityLevel": this.editObj['driverShift'][i].priorityLevel
            }
            let obj = { last }
            this.shiftObjects[i] = obj;
          }
        }
        this.editObj['driverShift'][i].priorityLevel == 'Primary' ? this.formObject['shift'] = this.editObj['driverShift'][i].shiftID : '';
      }
    }
    else {
      this.driverlists = this.getDriverOptions();
      let first = {
        "driverID":  this.editObj['driverID'],
        "driverName": this.editObj['driverName'] || (this.selectedDriver && this.selectedDriver[0]?.name) || '',
        "priorityLevel": 'Primary'
      }
      let obj = { first }
      this.shiftObjects[0]=obj;
    }
    
    // Update secondary shift list after loading form values
    this.updateSecondaryShiftList();
    this.syncSelectedSecondaryDriver();
  }

  getSelectedVehicle(e) {
    this.formObject['vehicle'] = e.value;
    if (this.formSubmitted) this.validation();
  }
  getSelectedDriver(e) {
    this.formObject['driver'] = e.value;
    if (this.formSubmitted) this.validation();
  }

  hasVehicleSelection() {
    return !!this.formObject.vehicle;
  }

  hasPrimaryShiftSelection() {
    return !!this.formObject.shift;
  }

  hasPrimaryDriverSelection() {
    return !!this.formObject.driver;
  }

  hasSecondaryShiftSelection() {
    return !!this.shiftObjects[1]?.second?.shiftID;
  }

  private normalizeToArray(value: any): string[] {
    if (value === null || value === undefined || value === '') {
      return [];
    }

    const values = Array.isArray(value) ? value : String(value).split(',');

    return values
      .map(item => String(item).trim().toLowerCase())
      .filter(item => item.length > 0);
  }

  private hasAnyCommonShift(driverShift: any, selectedShift: any): boolean {
    if (!selectedShift) {
      return true;
    }

    const driverShifts = this.normalizeToArray(driverShift);
    const selectedShifts = this.normalizeToArray(selectedShift);

    if (driverShifts.length === 0 || selectedShifts.length === 0) {
      return false;
    }

    return selectedShifts.some(shift => driverShifts.includes(shift));
  }

  private hasAnyCommonBranch(vehicleBranch: any, driverBranch: any): boolean {
    if (!vehicleBranch) {
      return true;
    }

    const vehicleBranches = this.normalizeToArray(vehicleBranch);
    const driverBranches = this.normalizeToArray(driverBranch);

    if (vehicleBranches.length === 0 || driverBranches.length === 0) {
      return false;
    }

    return vehicleBranches.some(branch => driverBranches.includes(branch));
  }

  shiftSelectionResult(e, index) {
    if (index != undefined) {
      if (index == 0) {
        if (this.shiftSelectValidation('first', 0)) {
          if (this.isEdit) {
            if (this.shiftObjects[1] == undefined) {
              let second = {
                "shiftID": e
              };
              let obj = { second }
              this.shiftObjects[1] = obj;
            } else {
              this.shiftObjects[1].second['shiftID'] = e;
            }
          } else {
            let second = {
              "shiftID": e
            };
            let obj = { second }
            this.shiftObjects[index + 1] = obj;
          }
          // Update secondary shift list after secondary shift is selected
          this.updateSecondaryShiftList();

          // Always clear selected secondary driver on user (re)selection in edit/add mode
          console.log('Secondary shift (re)selected - clearing secondary driver selection');
          this.driversEditData = [];
          if (this.shiftObjects[1]?.second) {
            this.shiftObjects[1].second.driverID = '';
            this.shiftObjects[1].second.driverName = '';
          }
          const matSelect = this.driverSelect;
          if (matSelect) {
            matSelect.value = null;
            matSelect.writeValue(null);
            matSelect.ngAfterContentInit();
          }

          // Filter drivers for secondary shift into separate list (do not force-include assigned drivers on user selection)
          if (this.selectedVehicleBranch) {
            console.log('Secondary shift set to:', e, '- Refreshing secondary driver list');
            const includeAssignedDriver = false;
            this.filterSecondaryDriversByBranchAndShift(this.selectedVehicleBranch, e, includeAssignedDriver);
          }
          if (this.formSubmitted) this.validation();
        } else {
          this.changeDetectorRef.detectChanges();
          this.shiftValues = [];
          const matSelect = this.shiftSelect;
          if (matSelect) {
            matSelect.value = null; // Clear the selected value
            matSelect.writeValue(null); // Reset the selection
            matSelect.ngAfterContentInit(); // Re-trigger the rendering
          }
          if (this.formSubmitted) this.validation();
        }

      }
      if (index == 1) {
        let third = {
          "shiftID": e
        };
        let obj = { third }
        this.shiftObjects[index + 1] = obj
      }
      if (index == 2) {
        let last = {
          "shiftID": e
        };
        let obj = { last }
        this.shiftObjects[index + 1] = obj
      }
    } else {
      this.formObject['shift'] = e;
      if (this.isEdit == true) {
        if (this.shiftObjects[0]?.first == undefined) {
          let first = {
            "shiftID": e
          };
          let obj = { first }
          this.shiftObjects[0] = obj;
        } else {
          this.shiftObjects[0]['first']['shiftID'] = e;
        }
      } else {
        let first = {
          "shiftID": e
        };
        let obj = { first }
        this.shiftObjects[0] = obj;
        if (this.formSubmitted) this.validation();
      }
      // Update secondary shift list after primary shift is selected
      this.updateSecondaryShiftList();
      
      // Detect if this is an actual shift change (not initial load)
      const isPrimaryShiftChanged = this.isEdit && this.initialPrimaryShift !== null && e !== this.initialPrimaryShift;
      const shouldClearDriver = !this.isEdit || isPrimaryShiftChanged;
      
      if (shouldClearDriver) {
        console.log('Primary shift changed - clearing driver selection');
        this.formObject.driver = '';
        // Clear selectedDriver array to prevent duplicate display
        this.selectedDriver = [];
      }
      
      // Filter drivers by selected shift (always refresh the list)
      if (this.selectedVehicleBranch) {
        console.log('Primary shift', isPrimaryShiftChanged ? 'changed' : 'set', 'to:', e, '- Refreshing driver list');
        // Don't include originally assigned driver if shift was changed
        const includeAssignedDriver = !isPrimaryShiftChanged;
        this.filterDriversByBranchAndShift(this.selectedVehicleBranch, e, includeAssignedDriver);
      }
      
      // Mark initial load as complete after first shift selection
      if (this.isInitialLoad) {
        this.isInitialLoad = false;
      }
    }
  }

  validation() {
    let objectKeys = Object.keys(this.formObject);
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObj[key] = '';
      if (this.formObject[key] == '' || this.formObject[key] == undefined || this.formObject[key] == null || this.formObject[key].length <= 0) {
        this.errorObj[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
        isValid = false;
      }
    }
    return isValid;
  }

  cancel() {
    this.router.navigate(['/organization/transport-manager/information/manage/view-manage', this.vendorID]);
  }

  async onSubmit() {
    this.formSubmitted = true;
    if (this.validation() && this.validationObj()) {
      let apiMethod = 'transportManagerAssignVehicleDriver';
      let obj = {
        vehRegNo: this.formObject.vehicle,
        driverID: this.formObject.driver,
        vendorID: this.vendorID
      }
      // this.checkVale
      if (this.isEdit) {
        apiMethod = 'transportManagerManageVehicleDriverUpdate';
        obj['oldDriverID'] = this.editObj['driverID'];
      }
      const { driverShift, drivers } = this.getDriverIDs(this.shiftObjects);
      obj['driverShift'] = driverShift;
      obj['drivers'] = drivers;
      this.api[apiMethod](obj).then((res: any) => {
        let responseStatus = '';
        let responseMsg: any;
        if (this.isEdit) {
          responseStatus = res.status;
          responseMsg = res.message;
        } else {
          responseStatus = res.response.status;
          responseMsg = res.response.message;
        }
        if (responseStatus == 'success') {
          this.swal.swalFunction(responseStatus, responseStatus, responseMsg, 2000);
          this.router.navigate(['/organization/transport-manager/information/manage/view-manage', this.vendorID]);
        } else {
          this.swal.swalFunction(responseStatus, responseStatus, responseMsg, 2000);
        }
      }).catch((err) => {
        console.log(err);
      });

    }
  }


  findMissingDriverIDs() {
    const missingDriverIDs = {};

    this.shiftObjects.forEach(driverObj => {
      const key = Object.keys(driverObj)[0];
      if (!driverObj[key].hasOwnProperty('driverID')) {
        missingDriverIDs[key] = false;
      }
    });

    return missingDriverIDs;
  }

  validationObj() {
    if ((this.shiftObjects[1]?.second?.shiftID != undefined) && (this.shiftObjects[1]?.second?.driverID == undefined || this.shiftObjects[1]?.second?.driverID?.length == 0)) {
      this.swal.swalFunction("warning", "warning", "Select the secondary driver to complete the setup!", 2000)
      return false
    } else {
      return true;
    }
    // const missingDriverIDs = this.findMissingDriverIDs();
    // console.log("missingDriverIDs",missingDriverIDs)
    // if (Object.keys(missingDriverIDs).length > 0) {
    //   console.log('Validation Error: Missing driverID for keys - ' + Object.keys(missingDriverIDs).join(', '))
    //   // throw new Error('Validation Error: Missing driverID for keys - ' + Object.keys(missingDriverIDs).join(', '));
    //   // this.comService.swa
    //   return false;
    // } else {
    //   return true;
    // }
  }
  getDriverIDs(driversData) {
    const flattenedDrivers = driversData.map(driverObj => Object.values(driverObj)[0]);

    // Ensure driverName is populated for each entry
    const withNames = flattenedDrivers.map(d => ({
      ...d,
      driverName: d.driverName || this.findDriverName(d.driverID) || ''
    }));

    const driverShift = withNames.sort((a, b) => {
      return a.priorityLevel == "Primary" ? -1 : 1;
    });
    
    // Get unique driver IDs
    const drivers = Array.from(new Set(driverShift.map(driver => driver.driverID)));

    return { driverShift, drivers };

  }

  private findDriverName(driverID: any): string | undefined {
    if (!driverID) return undefined;
    // Prefer selected primary driver
    if (this.formObject?.driver === driverID && this.selectedDriver?.[0]?.name) {
      return this.selectedDriver[0].name;
    }
    // Search current lists
    const inPrimary = this.driverlists.find(d => d.value === driverID);
    if (inPrimary) return inPrimary.name;
    const inSecondary = this.secondaryDriverlists.find(d => d.value === driverID);
    if (inSecondary) return inSecondary.name;
    const inAll = this.allDriversList.find(d => d.value === driverID);
    if (inAll) return inAll.name;
    // Fallback to edit object
      if (this.editObj && (this.editObj as any)['driverID'] === driverID) {
        return (this.editObj as any)['driverName'];
      }
      if (this.editObj && Array.isArray((this.editObj as any)['driverShift'])) {
        const matchedShiftDriver = (this.editObj as any)['driverShift'].find(d => d?.driverID === driverID);
        if (matchedShiftDriver?.driverName) {
          return matchedShiftDriver.driverName;
        }
      }
      return undefined;
    }

    private syncSelectedSecondaryDriver() {
      const secondaryDriverID = this.shiftObjects[1]?.second?.driverID || this.formObject['secondDriver'];
      if (!secondaryDriverID) {
        this.selectedSecondaryDriver = [];
        return;
      }

      const secondaryDriverName =
        this.shiftObjects[1]?.second?.driverName ||
        this.findDriverName(secondaryDriverID) ||
        '';

      if (!secondaryDriverName) {
        return;
      }

      this.selectedSecondaryDriver = [{
        name: secondaryDriverName,
        value: secondaryDriverID,
        driverPosition: 'secondary',
        badge: 'S',
        badgeClass: "bg-secondary text-white rounded-pill px-2 ml-2 badgePosRel"
      }];

      this.oldSecondaryDriver = {
        name: secondaryDriverName,
        value: secondaryDriverID
      };

      this.secondaryDriverlists = this.secondaryDriverlists.filter(driver => driver.value !== secondaryDriverID);
      this.driversEditData = secondaryDriverID;
      this.formObject['secondDriver'] = secondaryDriverID;
    }

  addDrivers() {
    // const newIndex = this.extraDrivers.length;
    // this.extraDrivers.push(newIndex);
    this.driverlists = this.getDriverOptions();
    // this.shiftDatas[newIndex] = this.getShifOption(newIndex);

  }

  getDriverOptions() {
    // Allow same driver or different driver to be assigned to multiple shifts
    // Return all available drivers from storedData
    return [...this.driverlists];
  }

  getShifOption(index: number) {
    return this.shiftTimeData
  }

  // removeDrivers(index: number): void {

  //   // let arr = this.extraDrivers.filter(value => value != index);
  //   // this.extraDrivers = arr.map((value, index) => index);
  //   if (index == 0) {
  //     this.shiftValues[index] = null;
  //     this.extraDrivers.splice(index, 1);
  //     this.removeAndReassignKeys(0);

  //   }
  //   if (index == 1) {
  //     this.removeAndReassignKeys(1)
  //     // this.shiftSelect.writeValue(null); 
  //     this.shiftValues[index] = null;
  //     // const matSelect = this.shiftSelects.toArray()[index];
  //     // if (matSelect) {
  //     //   matSelect.value = null; // Clear the selected value
  //     //   matSelect.writeValue(null); // Reset the selection
  //     //   matSelect.ngAfterContentInit(); // Re-trigger the rendering
  //     // }
  //     this.extraDrivers.splice(index, 1);
  //   }
  //   if (index == 2) {
  //     this.removeAndReassignKeys(2)
  //     this.shiftValues[index] = null;
  //     this.extraDrivers.splice(index, 1);
  //     // this.dropdownOptions[index]=null;
  //   }



  //   const key = index.toString();
  //   if (this.driverData.hasOwnProperty(key)) {
  //     if (this.additionalDri != undefined && this.additionalDri.length > 0) {
  //       let drivData;
  //       this.driverData[key].filter(data => {
  //         this.additionalDri.map((val, index) => {
  //           if (val == data.value) {
  //             this.additionalDri.splice(index, 1)
  //             drivData = data;
  //             delete this.driverData[key]
  //           }
  //         });
  //       });
  //       if (drivData != undefined) {
  //         this.pushDriverData(drivData)
  //       }
  //     } else {
  //       delete this.driverData[key]
  //     }
  //   }

  // }

  removeAndReassignKeys(indexToRemove) {
    this.shiftObjects.splice(indexToRemove + 1, 1);

    const keyNames = ['first', 'second', 'third', 'last'];

    this.shiftObjects = this.shiftObjects.map((item, index) => {
      const newKey = keyNames[index];
      return { [newKey]: item[Object.keys(item)[0]] };
    });

    return this.shiftObjects;
  }
  pushDriverData(driverObj) {
    for (let key in this.driverData) {
      if (this.driverData.hasOwnProperty(key)) {
        this.driverData[key].push(driverObj);
      }
    }
  }

  getVehicleBranch(vehRegNo: string) {
    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
      vehRegNo: vehRegNo
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      console.log('Full vehicle details:', res); // Debug log
      if (res.status == 'success' && res.data && res.data.length > 0) {
        const vehicle = res.data[0];
        console.log('Vehicle object:', vehicle); // Debug log
        let branchValue = vehicle.branch || vehicle.branchID || null;
        console.log('Raw branch value:', branchValue, 'Is Array?', Array.isArray(branchValue)); // Debug log
        this.selectedVehicleBranch = branchValue;
        console.log('Final selected vehicle branch:', this.selectedVehicleBranch, 'Type:', typeof this.selectedVehicleBranch); // Debug log
        
        // Reset and reload drivers list for the new vehicle's branch
        this.getUnassignedDriver();
        
        // Load shifts for the new vehicle's branch
        this.getListShift(this.selectedVehicleBranch);
      } else {
        // If vehicle details not found, show all shifts
        console.log('Vehicle details not found, showing all shifts');
        this.getListShift();
      }
    }).catch((err) => {
      console.log('Error fetching vehicle details:', err);
      // On error, show all shifts
      this.getListShift();
    });
  }
  
  getVehicleBranchForEdit(vehRegNo: string, secondaryDrivers: any[]) {
    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
      vehRegNo: vehRegNo
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      console.log('Full vehicle details in edit mode:', res); // Debug log
      if (res.status == 'success' && res.data && res.data.length > 0) {
        const vehicle = res.data[0];
        console.log('Vehicle object in edit mode:', vehicle); // Debug log
        let branchValue = vehicle.branch || vehicle.branchID || null;
        console.log('Raw branch value in edit mode:', branchValue, 'Is Array?', Array.isArray(branchValue)); // Debug log
        this.selectedVehicleBranch = branchValue;
        console.log('Edit mode - Final selected vehicle branch:', this.selectedVehicleBranch, 'Type:', typeof this.selectedVehicleBranch); // Debug log
        
        // Load drivers and shifts filtered by branch in edit mode
        this.getUnassignedDriver().then(() => {
          // After drivers are loaded, load shifts
          this.getListShift(this.selectedVehicleBranch);
          
          // After shifts and form values are loaded, filter drivers by their respective shifts
          setTimeout(() => {
            console.log('=== EDIT MODE DRIVER FILTERING START ===');
            console.log('shiftObjects:', JSON.stringify(this.shiftObjects));
            console.log('formObject.shift:', this.formObject.shift);
            console.log('selectedVehicleBranch:', this.selectedVehicleBranch);
            
            // Get primary shift from shiftObjects (more reliable than formObject.shift)
            const primaryShift = this.shiftObjects[0]?.first?.shiftID;
            console.log('Extracted primary shift from shiftObjects:', primaryShift);
            
            if (primaryShift && this.selectedVehicleBranch) {
              console.log('Edit mode - Filtering PRIMARY drivers by branch:', this.selectedVehicleBranch, 'and shift:', primaryShift);
              this.filterDriversByBranchAndShift(this.selectedVehicleBranch, primaryShift, true);
            } else {
              console.warn('Cannot filter primary drivers - missing data:', { primaryShift, selectedVehicleBranch: this.selectedVehicleBranch });
            }
            
            // Get secondary shift from shiftObjects - delay to avoid race condition
            setTimeout(() => {
              const secondaryShift = this.shiftObjects[1]?.second?.shiftID;
              const secondaryDriverID = this.shiftObjects[1]?.second?.driverID;
              console.log('Extracted secondary shift from shiftObjects:', secondaryShift);
              console.log('Extracted secondary driver from shiftObjects:', secondaryDriverID);
              
              if (secondaryShift && this.selectedVehicleBranch) {
                console.log('Edit mode - Filtering SECONDARY drivers by branch:', this.selectedVehicleBranch, 'and shift:', secondaryShift);
                this.filterSecondaryDriversByBranchAndShift(this.selectedVehicleBranch, secondaryShift, true);
                
                // After filtering, ensure driversEditData is set if secondary driver exists
                if (secondaryDriverID) {
                  setTimeout(() => {
                    console.log('Setting driversEditData to:', secondaryDriverID);
                    console.log('Available secondary drivers:', this.secondaryDriverlists);
                    this.driversEditData = secondaryDriverID;
                  }, 100);
                }
              } else {
                console.warn('Cannot filter secondary drivers - missing data:', { secondaryShift, selectedVehicleBranch: this.selectedVehicleBranch });
              }
              console.log('=== EDIT MODE DRIVER FILTERING END ===');
            }, 200);
          }, 150);
        });
      } else {
        // If vehicle details not found, show all data
        console.log('Vehicle details not found in edit mode, showing all data');
        this.getUnassignedDriver().then(() => {
          this.getListShift();
        });
      }
    }).catch((err) => {
      console.log('Error fetching vehicle details in edit mode:', err);
      // On error, show all data
      this.getUnassignedDriver().then(() => {
        this.getListShift();
      });
    });
  }
  getListShift(branchID?) {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.ListShift(obj).then((res: any) => {
      console.log('All shifts from API:', res.data); // Debug log
      console.log('Filtering by branchID:', branchID, 'Type:', typeof branchID); // Debug log
      if (res?.data?.length > 0 && res?.status == 'success') {
        if (branchID && branchID !== null && branchID !== undefined) {
          // Debug: Check each shift's branch value
          // console.log('Checking each shift:');
          res.data.forEach((shift, index) => {
            // console.log(`Shift ${index}: ${shift.shiftName}, branch: "${shift.branch}", branchID: "${shift.branchID}", comparing with: "${branchID}"`);
            // console.log(`  Match result: branch==${branchID} is ${shift.branch == branchID}, branchID==${branchID} is ${shift.branchID == branchID}`);
          });
          
          // Filter shifts by branch - compare both ID and name, case insensitive
          this.shiftTimeData = res.data.filter(shift => {
            const shiftBranch = shift.branch || shift.branchID || shift.branchName || null;
            return this.hasAnyCommonBranch(branchID, shiftBranch);
          });
          console.log('Filtered shifts:', this.shiftTimeData); // Debug log
          console.log('Number of filtered shifts:', this.shiftTimeData.length);
        } else {
          // If no branch is assigned to vehicle, show all shifts
          console.log('No branch assigned to vehicle, showing all shifts');
          this.shiftTimeData = res.data;
        }
      } else {
        this.shiftTimeData = [];
      }
      // Update secondary shift list after loading shifts
      this.updateSecondaryShiftList();
    }).catch((err) => {
      console.log(err);
    });
  }
  
  updateSecondaryShiftList() {
    // Allow the same shift for multiple drivers - show all shifts in secondary dropdown
    // console.log('updateSecondaryShiftList called');
    // console.log('formObject.shift:', this.formObject.shift);
    // console.log('shiftTimeData:', this.shiftTimeData);
    
    // Show all shifts, including the primary shift
    this.secondaryShiftData = [...this.shiftTimeData];
    // console.log('Secondary shift list (including all shifts):', this.secondaryShiftData);
  }

  extradriverSelection(value: any, index) {
    this.removeExtraDriver(value, index)
    if (index == 0) {
      // if(this.shiftObjects[1] == undefined){
      //   let second = {
      //     "shiftID": ''
      //   };
      //   let obj = { second }
      //   this.shiftObjects[1] = obj;
      // }
      if (this.shiftSelectValidation('second', 1)) {
        // OLD: this only assigned the secondary driver and did not keep a separate selected item like primary
        // const selectedDriver = this.secondaryDriverlists.find(driver => driver.value === value);
        // if(selectedDriver){
        //   selectedDriver['driverPosition'] = 'secondary';
        //   selectedDriver['badge'] = 'S';
        //   selectedDriver['badgeClass'] = "bg-secondary text-white rounded-pill px-2 ml-2 badgePosRel";
        // }
        // this.shiftObjects[1]['second']['driverID'] = value;
        // this.shiftObjects[1]['second']['driverName'] = selectedDriver ? selectedDriver.name : '';
        // this.shiftObjects[1]['second']['priorityLevel'] = "Secondary";
        // this.formObject['secondDriver'] = value;
        // this.additionalDri.push(value);

        // OLD:
        // this.oldSecondaryDriver = driverObj;

        // New: restore previously selected secondary driver back to dropdown before selecting a new one
        if (this.oldSecondaryDriver && this.oldSecondaryDriver.value) {
          const exists = this.secondaryDriverlists.find(driver => driver.value === this.oldSecondaryDriver.value);
          if (!exists) {
            this.secondaryDriverlists.push(this.oldSecondaryDriver);
          }
        }

        // New: keep currently selected secondary driver in a separate array like primary
        this.selectedSecondaryDriver = [];

        // New: find the selected secondary driver from dropdown options
        const selectedDriver = this.secondaryDriverlists.find(driver => driver.value === value);
        if (selectedDriver) {
          const driverObj = {
            ...selectedDriver,
            driverPosition: 'secondary',
            badge: 'S',
            badgeClass: "bg-secondary text-white rounded-pill px-2 ml-2 badgePosRel"
          };

          this.selectedSecondaryDriver.push(driverObj);
          this.shiftObjects[1]['second']['driverID'] = driverObj.value;
          this.shiftObjects[1]['second']['driverName'] = driverObj.name;
          this.shiftObjects[1]['second']['priorityLevel'] = "Secondary";
          this.formObject['secondDriver'] = driverObj.value;
          this.additionalDri.push(driverObj.value);

          // New: remove selected secondary driver from dropdown list like primary
          this.secondaryDriverlists = this.secondaryDriverlists.filter(driver => driver.value !== value);
          // New: keep a clean copy without badge fields when putting the old value back into the dropdown
          this.oldSecondaryDriver = { ...selectedDriver };
        }
      } else {
        this.changeDetectorRef.detectChanges();
        this.driversEditData = [];
        const matSelect = this.driverSelect;
        if (matSelect) {
          matSelect.value = null; // Clear the selected value
          matSelect.writeValue(null); // Reset the selection
          matSelect.ngAfterContentInit(); // Re-trigger the rendering
        }
        this.swal.swalFunction("warning", "warning", "Select the shift!", 2000)
      }
    }
    if (index == 1) {
      if (this.shiftSelectValidation('third', 2)) {
        // Find driver name from driverlists
        const selectedDriver = this.driverlists.find(driver => driver.value === value);
        this.shiftObjects[2]['third']['driverID'] = value;
        this.shiftObjects[2]['third']['driverName'] = selectedDriver ? selectedDriver.name : '';
        this.shiftObjects[2]['third']['priorityLevel'] = "Secondary";
        this.additionalDri.push(value);
      } else {
        // this.dropdownOptions[index]=null;
        this.changeDetectorRef.detectChanges();
        this.swal.swalFunction("warning", "warning", "Select the shift!", 2000)
      }
    }
    if (index == 2) {
      if (this.shiftSelectValidation('last', 3)) {
        // Find driver name from driverlists
        const selectedDriver = this.driverlists.find(driver => driver.value === value);
        if(selectedDriver){

          selectedDriver['driverPosition'] = 'secondary';
          selectedDriver['badge'] = 'S';
          selectedDriver['badgeClass'] = "bg-secondary text-white rounded-pill px-2 ml-2 badgePosRel";
        }
        this.shiftObjects[3]['last']['driverID'] = value;
        this.shiftObjects[3]['last']['driverName'] = selectedDriver ? selectedDriver.name : '';
        this.shiftObjects[3]['last']['priorityLevel'] = "Secondary";
        this.additionalDri.push(value);
      } else {
        // this.dropdownOptions[index]=null;
        this.changeDetectorRef.detectChanges();
        this.swal.swalFunction("warning", "warning", "Select the shift!", 2000)
      }

    }
  }

  removeExtraDriver(value, index) {
    Object.keys(this.driverData).forEach(key => {
      if (key != index) {
        this.driverData[key] = this.driverData[key].filter(driv => driv.value != value)
      }
    });
  }
  resetValue() {
    this.driversEditData = [];
    this.shiftValues = [];
    // New: clear selected secondary driver state on reset
    this.selectedSecondaryDriver = [];
    this.oldSecondaryDriver = {};
    this.shiftObjects.splice(1, 1)
    // Update secondary shift list after reset
    this.updateSecondaryShiftList();
    // delete this.shiftObjects[1].second
    //   if (this.shiftObjects[1] && this.shiftObjects[1].second) {
    //     for (let key in this.shiftObjects[1].second) {
    //         if (this.shiftObjects[1].second.hasOwnProperty(key)) {
    //           this.shiftObjects[1].second[key] = '';
    //         }
    //     }
    // }
  }

  // filterDriversByBranch(branchID: any) {
  //   console.log('Filtering drivers by branchID:', branchID); // Debug log
  //   console.log('All drivers list:', this.allDriversList); // Debug log
    
  //   if (!branchID || branchID === null || branchID === undefined) {
  //     console.log('No branch filter, showing all drivers');
  //     this.driverlists = [...this.allDriversList];
  //     this.storedData = [...this.allDriversList];
  //     return;
  //   }

  //   // Extract branchID if it's an array
  //   let filterBranchID = branchID;
  //   if (Array.isArray(branchID) && branchID.length > 0) {
  //     filterBranchID = branchID[0];
  //   }

  //   // Get full driver details with proper branch IDs and shift info
  //   this.getDriversWithBranchDetails(filterBranchID);
  // }
  
  filterDriversByBranchAndShift(branchID: any, shiftID: any, includeAssignedDriver: boolean = true) {
    // console.log('=== filterDriversByBranchAndShift (PRIMARY) START ===');
    // console.log('Filtering by branchID:', branchID, 'and shiftID:', shiftID, 'includeAssignedDriver:', includeAssignedDriver);
    
    // Extract branchID if it's an array
    let filterBranchID = branchID;
    if (Array.isArray(branchID) && branchID.length > 0) {
      filterBranchID = branchID[0];
    }
    
    // Get full driver details with branch and shift filtering for PRIMARY dropdown
    this.getDriversWithBranchAndShiftDetails(filterBranchID, shiftID, 'primary', includeAssignedDriver);
  }
  
  filterSecondaryDriversByBranchAndShift(branchID: any, shiftID: any, includeAssignedDriver: boolean = true) {
    // console.log('=== filterSecondaryDriversByBranchAndShift START ===');
    // console.log('Filtering by branchID:', branchID, 'and shiftID:', shiftID, 'includeAssignedDriver:', includeAssignedDriver);
    
    // Extract branchID if it's an array
    let filterBranchID = branchID;
    if (Array.isArray(branchID) && branchID.length > 0) {
      filterBranchID = branchID[0];
    }
    
    // Get full driver details with branch and shift filtering for SECONDARY dropdown
    this.getDriversWithBranchAndShiftDetails(filterBranchID, shiftID, 'secondary', includeAssignedDriver);
  }
  
  getDriversWithBranchAndShiftDetails(branchID: any, shiftID: any, dropdownType: string = 'primary', includeAssignedDriver: boolean = true) {
    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID
    };
    
    // console.log(`getDriversWithBranchAndShiftDetails called for ${dropdownType} with branchID:`, branchID, 'shiftID:', shiftID);
    // console.log('allDriversList length:', this.allDriversList.length);
    
    this.api.transportManagerDriverList(obj).then((res: any) => {
      // console.log('=== DRIVER LIST API RESPONSE ===');
      // console.log('Response status:', res.status);
      // console.log('Total drivers from API:', res.data?.length);
      if (res.status === 'success' && res.data) {
        
        // Get list of unassigned driver IDs
        const unassignedDriverIDs = this.allDriversList.map(d => d.value);
        // console.log('Unassigned driver IDs:', unassignedDriverIDs);
        
        // Get assigned driver IDs from edit mode (both original and currently selected)
        const assignedDriverIDs = [];
        if (this.isEdit) {
          // Always include original primary and secondary drivers from editObj (if includeAssignedDriver is true)
          if (includeAssignedDriver) {
            if (this.editObj['driverID']) {
              assignedDriverIDs.push(this.editObj['driverID']);
            }
            if (this.editObj['driverShift']?.[1]?.driverID) {
              assignedDriverIDs.push(this.editObj['driverShift'][1].driverID);
            }
          }
          
          // ALWAYS include currently selected drivers (regardless of includeAssignedDriver flag)
          // This allows multiple swaps without updating
          if (this.formObject.driver && !assignedDriverIDs.includes(this.formObject.driver)) {
            assignedDriverIDs.push(this.formObject.driver);
          }
          if (this.shiftObjects[1]?.second?.driverID && !assignedDriverIDs.includes(this.shiftObjects[1].second.driverID)) {
            assignedDriverIDs.push(this.shiftObjects[1].second.driverID);
          }
          
          // console.log('Assigned driver IDs for', dropdownType, '(original + currently selected):', assignedDriverIDs);
        }
        
        // Filter for unassigned drivers with matching branch AND shift
        const filteredDrivers = res.data.filter(driver => {
          const isAssignedDriver = assignedDriverIDs.includes(driver.driverID);

          // Allow currently assigned drivers in edit mode when we explicitly need to keep them visible.
          if (includeAssignedDriver && isAssignedDriver) {
            // console.log(`Including currently assigned driver: ${driver.name}`);
            return true;
          }

          // For normal add/update selection, dropdowns should only show unassigned drivers.
          if (!unassignedDriverIDs.includes(driver.driverID)) {
            return false;
          }
          
          // Get driver branch
          const driverBranch = driver.branch || driver.branchID || driver.branchName || null;
          
          // Check branch match
          const branchMatch = this.hasAnyCommonBranch(branchID, driverBranch);
          
          // Get driver shift. Drivers can have multiple shifts like ['General', 'Night'].
          const driverShift = driver.shift || driver.shiftID || driver.shiftName || null;
          
          // Match if any selected shift exists in the driver's shift array/string.
          const shiftMatch = this.hasAnyCommonShift(driverShift, shiftID);
          
          const match = branchMatch && shiftMatch;
          // console.log(`Driver ${driver.name}: branchMatch=${branchMatch} ("${driverBranch}" vs "${branchID}"), shiftMatch=${shiftMatch} ("${driverShift}" vs "${shiftID}"), finalMatch=${match}`);
          return match;
        });
        
        
        // console.log('Filtered drivers count:', filteredDrivers.length);
        // console.log('Filtered driver names:', filteredDrivers.map(d => d.name));
        
        // Map to driver objects and assign to correct list based on dropdown type
        const mappedDrivers = filteredDrivers.map(driver => ({
          name: driver.name,
          value: driver.driverID,
          branch: driver.branch || driver.branchID || null,
          shift: driver.shift || driver.shiftID || null
        }));
        
        // console.log('Mapped drivers:', mappedDrivers);
        
        if (dropdownType === 'secondary') {
          let filteredSecondary = mappedDrivers;
          const primaryDriverID = this.formObject.driver;
          const selectedSecondaryDriverID = this.shiftObjects[1]?.second?.driverID || this.formObject['secondDriver'];

          // Keep selected primary driver out of the secondary options.
          if (primaryDriverID) {
            filteredSecondary = filteredSecondary.filter(d => d.value !== primaryDriverID);
          }

          // Keep selected secondary driver out of the normal dropdown options.
          if (selectedSecondaryDriverID) {
            filteredSecondary = filteredSecondary.filter(d => d.value !== selectedSecondaryDriverID);
          }

          this.secondaryDriverlists = filteredSecondary;
          this.syncSelectedSecondaryDriver();
          // console.log('Final secondaryDriverlists:', this.secondaryDriverlists);
          //console.log('Number of filtered secondary drivers:', this.secondaryDriverlists.length);
        } else {
          let filteredPrimary = mappedDrivers;
          const selectedSecondaryDriverID = this.shiftObjects[1]?.second?.driverID || this.formObject['secondDriver'];

          if (this.formObject.driver) {
            filteredPrimary = filteredPrimary.filter(d => d.value !== this.formObject.driver);
          }

          // Keep selected secondary driver out of the primary options.
          if (selectedSecondaryDriverID) {
            filteredPrimary = filteredPrimary.filter(d => d.value !== selectedSecondaryDriverID);
          }

          this.driverlists = filteredPrimary;
          this.storedData = [...this.driverlists];
        }
       
      } else {
        // If we can't get full details, show all unassigned drivers
        // console.log('Could not fetch full driver details, showing all unassigned drivers');
        if (dropdownType === 'secondary') {
          this.secondaryDriverlists = [...this.allDriversList];
        } else {
          this.driverlists = [...this.allDriversList];
          this.storedData = [...this.allDriversList];
        }
      }
    }).catch((err) => {
      // console.error('Error fetching driver details:', err);
      // On error, show all unassigned drivers
      if (dropdownType === 'secondary') {
        this.secondaryDriverlists = [...this.allDriversList];
      } else {
        this.driverlists = [...this.allDriversList];
        this.storedData = [...this.allDriversList];
      }
    });
  }
  

  getDriversWithBranchDetails(branchID: any) {
    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID
    };
    
    // console.log('getDriversWithBranchDetails called with branchID:', branchID);
    // console.log('allDriversList length:', this.allDriversList.length);
    
    this.api.transportManagerDriverList(obj).then((res: any) => {
      // //console.log('Full driver list response:', res);
      if (res.status === 'success' && res.data) {
        // console.log('Total drivers from API:', res.data.length);
        
        // Get list of unassigned driver IDs
        const unassignedDriverIDs = this.allDriversList.map(d => d.value);
        // console.log('Unassigned driver IDs:', unassignedDriverIDs);
        
        // Get currently assigned driver IDs from edit mode
        const assignedDriverIDs = [];
        if (this.isEdit && this.selectedDriver.length > 0) {
          assignedDriverIDs.push(this.selectedDriver[0].value);
          // console.log('Currently assigned driver IDs:', assignedDriverIDs);
        }
        
        // Filter for unassigned drivers with matching branch OR currently assigned drivers
        const filteredDrivers = res.data.filter(driver => {
          // Include currently assigned drivers regardless of branch
          if (assignedDriverIDs.includes(driver.driverID)) {
            // console.log(`Including currently assigned driver: ${driver.name}`);
            return true;
          }
          
          // Check if driver is in unassigned list
          if (!unassignedDriverIDs.includes(driver.driverID)) {
            //console.log(`Driver ${driver.name} (${driver.driverID}) is not in unassigned list, skipping`);
            return false;
          }
          
          // Get driver branch - could be branch name or branchID
          const driverBranch = driver.branch || driver.branchID || driver.branchName || null;
          
          const match = this.hasAnyCommonBranch(branchID, driverBranch);
          //console.log(`Driver ${driver.name}: driverBranch="${driverBranch}" vs branchID="${branchID}" = ${match}`);
          return match;
        });
        
        //console.log('Filtered drivers count:', filteredDrivers.length);
        
        // Map to driver objects
        this.driverlists = filteredDrivers.map(driver => ({
          name: driver.name,
          value: driver.driverID,
          branch: driver.branch || driver.branchID || null
        }));
        
        //console.log('Final driverlists:', this.driverlists);
        //console.log('Number of filtered drivers:', this.driverlists.length);
        
        // Update storedData to match filtered drivers
        this.storedData = [...this.driverlists];
      } else {
        // If we can't get full details, show all unassigned drivers
        //console.log('Could not fetch full driver details, showing all unassigned drivers');
        this.driverlists = [...this.allDriversList];
        this.storedData = [...this.allDriversList];
      }
    }).catch((err) => {
      // console.error('Error fetching driver details:', err);
      // On error, show all unassigned drivers
      this.driverlists = [...this.allDriversList];
      this.storedData = [...this.allDriversList];
    });
  }
}
